import DateFnsUtils from "@date-io/date-fns";
import { ThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import HttpInterceptor from "../clients/HttpInterceptor";
import { AuthProvider } from "./AuthContext";
import { DplAlertProvider } from "./DplAlertContext";
import { useDplTheme } from "./DplThemeContext";
import { MetadataProvider } from "./MetadataContext";
import { NavigationProvider } from "./NavigationContext";
import { ProspectEventProvider } from "./ProspectEventContext";
import { SiteAlertProvider } from "./SiteAlertContext";
import { TaskProvider } from "./TaskContext";
import { VisibilityProvider } from "./VisibilityContext";

const Providers: React.FC = ({ children }) => {
  const { theme } = useDplTheme();

  // const theme = darkMode ? DarkTheme : LightTheme;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <SiteAlertProvider>
        <AuthProvider>
          <VisibilityProvider>
            <HttpInterceptor>
              <ThemeProvider theme={theme}>
                <MetadataProvider>
                  <ProspectEventProvider>
                    <NavigationProvider>
                      <DplAlertProvider>
                        <TaskProvider>{children}</TaskProvider>
                      </DplAlertProvider>
                    </NavigationProvider>
                  </ProspectEventProvider>
                </MetadataProvider>
              </ThemeProvider>
            </HttpInterceptor>
          </VisibilityProvider>
        </AuthProvider>
      </SiteAlertProvider>
    </MuiPickersUtilsProvider>
  );
};

export default Providers;
